import React from 'react';
import { useEffect } from 'react';
import ObjectItem from './Object';
import { TYPE_LABEL, TYPE_OPTION, TYPE_PROPERTY, TYPE_VALUE } from './types';
import { ChartNoAxesGantt } from 'lucide-react';

export default class OptionObjectItem extends ObjectItem {
  accept = []
  title = "option-object"
  model = TYPE_OPTION
  icon = ChartNoAxesGantt

  ItemContent = () => {
    const { props: { children, updateItem, component: { data } } } = this

    useEffect(() => {
      !data && updateItem({
        data: [
          {
            type: TYPE_PROPERTY,
            value: "{label}",
            model: TYPE_LABEL
          },
          {
            type: TYPE_PROPERTY,
            value: "{value}",
            model: TYPE_VALUE
          }
        ]
      })
    }, [])

    return children
  }
}